import React, { createContext, useContext, ReactNode } from 'react';
import { useAdminCheck } from '@/hooks/useAdminCheck';

interface AdminBypassContextType {
  isAdmin: boolean;
  checking: boolean;
  canBypassDateRestrictions: boolean;
}

const AdminBypassContext = createContext<AdminBypassContextType>({
  isAdmin: false,
  checking: true,
  canBypassDateRestrictions: false,
});

export const AdminBypassProvider = ({ children }: { children: ReactNode }) => {
  const { isAdmin, checking } = useAdminCheck();
  
  return (
    <AdminBypassContext.Provider 
      value={{ 
        isAdmin, 
        checking,
        canBypassDateRestrictions: isAdmin 
      }}
    >
      {children}
    </AdminBypassContext.Provider>
  );
};

export const useAdminBypass = () => useContext(AdminBypassContext);
